import React, { useState } from 'react';
import Navbar from '../layout/Navbar';


import SPC1 from '../assets/SPC1.png';
import SPC2 from '../assets/SPC2.png';
import SPC3 from '../assets/SPC3.png';
import SPC4 from '../assets/SPC4.png';
import RPC1 from '../assets/RPC1.jpeg';
import RPC2 from '../assets/RPC2.jpeg';
import RPC3 from '../assets/RPC3.jpeg';
import RPC4 from '../assets/RPC4.jpeg';
import DPC1 from '../assets/DPC1.jpeg';
import DPC3 from '../assets/DPC3.png';
import DPC4 from '../assets/DPC4.jpeg';

const products = [
    {
        id: 'spc6',
        title: '7oz Single Wall Paper Cup',
        image: SPC1,
        description1: 'Compact and stylish, perfect for tea and water servings.',
        description: 'A popular choice for serving small portions like tea or cold beverages, combining lightweight design with print customization options.',
        details: [
            'Dimensions: Bottom Dia 52mm x Height 75mm, Upper Dia 72mm',
            'Material: Paper',
            'Color: Single/Multi-color',
        ],
    },
    {
        id: 'spc5',
        title: '8oz Single Wall Paper Cup',
        image: SPC2,
        description1: 'Balanced size with great grip and premium look.',
        description: 'Ideal for tea and soft drinks, this is a versatile option in the paper disposables range with quality paper and clean finish.',
        details: [
            'Dimensions: Bottom Dia 54mm x Height 92mm, Upper Dia 80mm',
            'Material: Paper',
            'Color: Single/Multi-color',
        ],
    },
    {
        id: 'spc3',
        title: '12oz Single Wall Paper Cup',
        image: SPC3,
        description1: 'Spacious and sturdy, designed for larger beverage servings.',
        description: 'A reliable solution for cold beverages and branding needs, offering generous capacity with full-color printing flexibility.',
        details: [
            'Dimensions: Bottom Dia 58mm x Height 110mm, Upper Dia 90mm',
            'Material: Paper',
            'Color: Single/Multi-color',
        ],
    },
    {
        id: 'spc4',
        title: '16oz Single Wall Paper Cup',
        image: SPC4,
        description1: 'High-capacity cup for chilled drinks and branding.',
        description: 'Designed for large servings like cold coffees or soft drinks, this cup offers excellent print area and durability.',
        details: [
            'Dimensions: Bottom Dia 58mm x Height 137mm, Upper Dia 90mm',
            'Material: Paper',
            'Color: Single/Multi-color',
        ],
    },
    {
        id: 'rpc1',
        title: '7oz Ripple Wall Paper Cup',
        image: RPC1,
        description1: 'Textured ripple design ensures grip and insulation.',
        description:
            'Compact yet effective, this ripple cup keeps drinks hot while offering a safe, stylish grip for tea or espresso.',
        details: [
            'Dimensions: Bottom Dia 52mm x Height 75mm, Upper Dia 72mm',
            'Material: Paper',
            'Color: Customised',
        ],
    },
    {
        id: 'rpc2',
        title: '8oz Ripple Wall Paper Cup',
        image: RPC2,
        description1: 'Ideal size with double-wall insulation and ripple texture.',
        description:
            'Keeps beverages warm and hands safe, making it a perfect option for coffee vendors and hot drink counters.',
        details: [
            'Dimensions: Bottom Dia 54mm x Height 92mm, Upper Dia 80mm',
            'Material: Paper',
            'Color: Customised',
        ],
    },
    {
        id: 'rpc3',
        title: '12oz Ripple Wall Paper Cup',
        image: RPC3,
        description1: 'Strong thermal barrier with comfortable hand feel.',
        description:
            'Crafted for hot drinks, this size balances insulation, comfort, and brand visibility through ripple kraft outer layering.',
        details: [
            'Dimensions: Bottom Dia 58mm x Height 110mm, Upper Dia 90mm',
            'Material: Paper',
            'Color: Customised',
        ],
    },
    {
        id: 'rpc4',
        title: '16oz Ripple Wall Paper Cup',
        image: RPC4,
        description1: 'Perfect for large hot drinks with safe handling.',
        description:
            'A premium pick for cafes and takeaways, offering insulation, comfort, and brand-friendly surface in a ripple-wrapped design.',
        details: [
            'Dimensions: Bottom Dia 58mm x Height 137mm, Upper Dia 90mm',
            'Material: Paper',
            'Color: Customised',
        ],
    },
    {
        id: 'dpc1',
        title: '8oz Double Wall Paper Cup',
        image: DPC1,
        description1: 'Dual layers with air pocket for better heat resistance.',
        description:
            'A perfect mid-sized option, this double-wall cup keeps drinks warm and hands cool—great for coffee, tea, and cocoa.',
        details: [
            'Dimensions: Bottom Dia 54mm x Height 92mm, Upper Dia 80mm',
            'Material: Paper',
            'Color: Single/Multi-color',
        ],
    },
    {
        id: 'dpc3',
        title: '12oz Double Wall Paper Cup',
        image: DPC3,
        description1: 'Extra comfort and heat retention for longer sips.',
        description:
            'Best for moderate-to-large servings, offering superior insulation and a sleek exterior for hot beverages.',
        details: [
            'Dimensions: Bottom Dia 58mm x Height 110mm, Upper Dia 90mm',
            'Material: Paper',
            'Color: Single/Multi-color',
        ],
    },
    {
        id: 'dpc4',
        title: '16oz Double Wall Paper Cup',
        image: DPC4,
        description1: 'Premium design for hot beverages in large portions.',
        description:
            'Ideal for extended drinks like lattes or soups, this durable double-wall cup keeps drinks warmer for longer with added hand protection.',
        details: [
            'Dimensions: Bottom Dia 58mm x Height 137mm, Upper Dia 90mm',
            'Material: Paper',
            'Color: Single/Multi-color',
        ],
    },
];

const PaperCup = () => {
    const [openModal, setOpenModal] = useState(null);

    const closeModal = () => setOpenModal(null);

    const selectedProduct = products.find((p) => p.id === openModal);

    return (
        <>
            <Navbar />
            <section id="products" className="py-20 bg-gray-100">
                <div className="container mx-auto px-5">
                    <h2 className="text-center text-4xl mb-16 text-[#2c5530] font-bold relative after:content-[''] after:absolute after:bottom-[-10px] after:left-1/2 after:-translate-x-1/2 after:w-24 after:h-1 after:bg-gradient-to-r after:from-[#ff6b6b] after:to-[#ffa500] after:rounded">
                        Paper Cups
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mt-12">
                        {products.map(({ id, title, image, description1 }) => (
                            <div
                                key={id}
                                className="product-card bg-white rounded-2xl overflow-hidden shadow-xl 
                hover:-translate-y-2 hover:shadow-2xl transition-all cursor-pointer"
                                onClick={() => setOpenModal(id)}
                            >
                                <div className="h-48 bg-white flex items-center justify-center">
                                    <img src={image} alt={title} style={{ width: '200px', height: '200px' }} />
                                </div>
                                <div className="p-6">
                                    <h3 className="text-xl text-[#2c5530] mb-2 font-semibold">{title}</h3>
                                    <p className="text-sm text-gray-600">{description1}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Modal */}
            {selectedProduct && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
                    onClick={closeModal}
                >
                    <div
                        className="bg-white p-6 rounded-lg w-full max-w-md relative shadow-lg"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            onClick={closeModal}
                            className="absolute top-2 right-3 text-gray-600 text-2xl font-bold"
                            aria-label="Close modal"
                        >
                            &times;
                        </button>
                        <h3 className="text-2xl text-[#2c5530] font-semibold mb-4">{selectedProduct.title}</h3>
                        <img
                            src={selectedProduct.image}
                            alt={selectedProduct.title}
                            className="w-full h-48 object-contain mb-4"
                        />
                        <p className="mb-2">{selectedProduct.description}</p>
                        <ul className="list-disc pl-5 text-sm">
                            {selectedProduct.details.map((detail, idx) => (
                                <li key={idx}>{detail}</li>
                            ))}
                        </ul>
                    </div>
                </div>
            )}
        </>
    );
};

export default PaperCup;
